import '../styles/global.css';

export default function Form({ campos = [], onSubmit, onCancel, submitLabel = 'Guardar' }) {
    return (
        <form onSubmit={onSubmit} className='fill-form'>
            {campos.map((campo, i) => {
                const fullRow = campo.fullRow
                    ? { gridColumn: '1 / -1' }
                    : {};
                if (campo.render) {
                    return (
                        <div key={i} style={fullRow}>
                            {campo.label && <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4 }}>{campo.label}</label>}
                            {campo.render()}
                        </div>
                    );
                }
                return (
                    <div key={i} style={fullRow}>
                        {campo.label && <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4 }}>{campo.label}</label>}

                        {campo.type === 'select' ? (
                            <select className="form-input" value={campo.value} onChange={e => campo.onChange(e.target.value)} required={campo.required}>
                                {campo.options.map(op => (
                                    <option key={op.value ?? op} value={op.value ?? op}>
                                        {op.label ?? op}
                                    </option>
                                ))}
                            </select>
                        ) : campo.type === 'textarea' ? (
                            <textarea className="form-input" placeholder={campo.placeholder} value={campo.value} onChange={e => campo.onChange(e.target.value)} required={campo.required} />
                        ) : (
                            <input className="form-input" type={campo.type ?? 'text'} placeholder={campo.placeholder} value={campo.value} onChange={e => campo.onChange(e.target.value)} required={campo.required} />
                        )}
                    </div>
                );
            })}

            {/* Botones siempre al final */}
            <div style={{ gridColumn: '1 / -1', display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                {onCancel && <button type="button" className="btn-secondary" onClick={onCancel}>Cancelar</button>}
                <button type="submit" className="btn-primary">{submitLabel}</button>
            </div>
        </form>
    );
}